import {
  NgClass,
  NgStyle,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
} from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLinkWithHref } from '@angular/router';
import { ActionButtonOrLinkComponent } from '@shared/components/UI/action-button-or-link/action-button-or-link.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Toast } from 'ngx-toastr';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ActionButtonOrLinkComponent],
  imports: [
    MatTooltipModule,
    MatIconModule,
    NgSwitchCase,
    NgSwitch,
    NgSwitchDefault,
    RouterLinkWithHref,
    NgStyle,
    NgClass,
    TooltipModule,
    Toast,
    MatButtonModule,
  ],
  exports: [ActionButtonOrLinkComponent],
})
export class ActionButtonOrLinkModule {}
